/* @flow */

import * as React from "react";
import { connect } from "../../../../../utils/storeConnect";
import { SessionStore } from "../../../../../uidispatcherapi/SessionStore";
import BrandbarAccountInformation from "../BrandbarAccountInformation";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { getCustomerTierLevel } from "../../../../../stores/SessionStore";
import { trackFallbackDisplayOnError } from "../../../../../utils/AccountFlyoutTrackingUtil";
import { MetroXAccountFlyout } from "./MetroXAccountFlyout";
import { History } from "history";
import { shouldUseMetroXAccountFlyout } from "../../../../../featureToggles";

type Props = {
    isLoggedIn: boolean | null | undefined;
    isEmployee: boolean | null | undefined;
    tierLevel: string | null | undefined;
    idamToken: string | null | undefined;
    loginFailed: boolean | null | undefined;
    forceFlyout?: boolean | null | undefined;
    history?: History;
};

class MetroXAccountWrapper extends React.Component<Props> {
    renderAccountInfoComponent() {
        return (
            <BrandbarAccountInformation
                className="test-brandbar-account-info-component"
                isMetroX
                history={this.props.history}
            />
        );
    }

    renderFallback(props: FallbackProps) {
        trackFallbackDisplayOnError(this.props.tierLevel || "");
        console.error("The account flyout could not be rendered", props);
        return this.renderAccountInfoComponent();
    }

    render() {
        if (
            shouldUseMetroXAccountFlyout() &&
            !this.props.isEmployee &&
            (this.props.isLoggedIn || (this.props.loginFailed && this.props.forceFlyout))
        ) {
            return (
                <ErrorBoundary fallbackRender={this.renderFallback.bind(this)}>
                    <MetroXAccountFlyout tierLevel={this.props.tierLevel || ""} idamToken={this.props.idamToken} />
                </ErrorBoundary>
            );
        }
        return this.renderAccountInfoComponent();
    }
}

export default connect(
    {
        stores: [
            [
                SessionStore,
                (store: typeof SessionStore) => ({
                    isLoggedIn: store.loggedIn(),
                    isEmployee: store.isEmployee(),
                    tierLevel: getCustomerTierLevel(),
                    loginFailed: store.failed(),
                    idamToken: store.getIdamAccessToken()
                })
            ]
        ]
    },
    MetroXAccountWrapper
);
